<div class="card" *ngIf="this.entities?.length >=1" [ngStyle]="{'margin-bottom': (isOperator) ? '2em' : '0'}">
  <div class="card-header card-title">
    <h5 class="m-0 p-0 d-flex justify-content-between">
      <span class="float-start" i18n="@@RunningTransacttions">Aktive Ladevorgänge</span>
      <strong *ngIf="transactionTotalPower">
        Gesamtladeleistung:&nbsp;<span class="font-weight-black">{{ transactionTotalPower | kwh }}&nbsp;kW</span>
      </strong>
    </h5>
  </div>

  <div class="card-body">
    <ng-container *ngFor="let transaction of this.entities; index as i; trackBy: trackBy('trans.id')">
      <ng-container>
        <div class="box trigger" (click)="selectTransaction(transaction.id)" style="cursor: pointer">
          <div class="p-3">
            <h6>
              <span class="float-start">
                {{ transaction.chargingStationName }} {{ getChargingPointPosition(transaction) }}
              </span>
              <span class="status-icon float-end" *ngIf="transaction.status == 3">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-zap">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                </svg>
              </span>
              <span class="status-icon float-end"
                *ngIf="transaction.status == 7 || transaction.status == 8 || transaction.status == 9">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-info">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
              </span>
            </h6>

            <h5 class="card-title">
              <ng-container *ngIf="transaction.isFreeCharge">
                <span i18n="@@Free">Kostenlos</span>
              </ng-container>
              <ng-container *ngIf="transaction.paymentIntentId != null">
                <span i18n="@@GuestViaQrCode">Gast über QR-Code</span>
              </ng-container>
              <ng-container *ngIf="transaction.sessionId != null">
                <span i18n="@@GuestViaRoaming">Gast über eRoaming</span>
              </ng-container>
              <ng-container *ngIf="transaction.hecId != null">
                <span i18n="@@GuestViaTerminal">Gast über Terminal</span>
              </ng-container>
              <ng-container *ngIf="transaction.userFirstName != null">
                {{ transaction.userFirstName }} {{ transaction.userLastName}}
              </ng-container>
            </h5>

            <div style="display: flex; flex-wrap: wrap; gap: .25rem;">
              <transaction-status-badge [status]="transaction.status"> </transaction-status-badge>

              <charging-power-profile-badge
                *ngIf="transaction && transaction.status && transaction.chargingPowerProfile"
                [profile]="transaction.chargingPowerProfile" [isCaptioned]="transaction.status.id == 3">
              </charging-power-profile-badge>

              <charging-power-profile-badge
                *ngIf="transaction && transaction.status && !transaction.chargingPowerProfile"
                [profile]="{ id: 1, name: 'Standard', key: 'now'}" [isCaptioned]="transaction.status.id == 3">
              </charging-power-profile-badge>

              <span class="badge" style="background: transparent;" [ngClass]="['profile-' + transaction.chargingPowerProfile?.key, 'colored']">
                <span *ngIf="transaction.currentPower" >{{ transaction.currentPower | kwh }}&nbsp;kW</span>
              </span>
            </div>

          </div>

          <small class="text-muted float-start d-flex py-2 px-3 mt-0" style="background: whitesmoke"
            [style]="transaction.currentSoC ? '' : 'border-bottom: 3px solid transparent'"
            i18n="@@TransactionDurationText">
            <span>{{ transaction.duration }}</span>
            <strong class="ms-auto text-orange" *ngIf="transaction.currentSoC">{{ transaction.currentSoC }}%</strong>
          </small>

          <div *ngIf="transaction.currentSoC" class="d-flex align-items-center gap-2">
            <div class="progress" role="progressbar" aria-label="State of Charge" [aria-valuenow]="transaction.currentSoC" aria-valuemin="0"
              aria-valuemax="100">
              <div class="progress-bar" [style.width.%]="transaction.currentSoC">
                <div class="charging"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="card-footer d-flex justify-content-end">
    <select class="form-select w-auto me-2" (change)="sortEntities($event)">
      <option value="starttime">Startzeit</option>
      <option value="status">Status</option>
    </select>
    <button id="sort_active_transaction" class="btn btn-sm btn-yellow d-flex gap-2 align-items-center"
            (click)="sortEntities()">
      <i class="ri-arrow-up-down-line" *ngIf="!(this.sortDirection =='asc' || this.sortDirection=='desc')"></i>
      <i class="ri-sort-asc" *ngIf="this.sortDirection =='asc'"></i>
      <i class="ri-sort-desc" *ngIf="this.sortDirection =='desc'"></i>
    </button>
  </div>
</div>

<running-transaction-popup [transaction]="selectedTransaction" [isOpen]="isViewingSelectedTransaction"
  (isClosing)="closePopup()">
</running-transaction-popup>
